import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    labelWrapper: {
      position: 'absolute',
      top: 12,
      left: 12,
    },
  }),
);
export default useStyles;
